export const FlowTypes = Object.freeze({
  CHOOSEPROVIDER: 'ChooseProvider',
  E911: '911',
  PROVIDERPROFILE: 'ProviderProfile',
  OBGYN: 'OBGYN'
})
